import styled from '@emotion/styled';
import { H2, SmallText } from 'ds/components/typography';

export const PriceWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5),
  marginTop: theme.spacing(1),
}));

export const FullPrice = styled.div(({ theme }) => ({
  fontSize: 17,
  fontWeight: 300,
  color: theme.colors.neutrals.grey4,
  textDecoration: 'line-through',
}));

export const CardWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(3),
  [theme.media.createCustomObjectMediaQuery('960px', '1001px')]: {
    marginRight: '-' + theme.spacing(4),
    marginLeft: '-' + theme.spacing(4),
  },
  [theme.media.createObjectMediaQuery({ to: 2 })]: {
    flexDirection: 'column',
    marginRight: 0,
    marginLeft: 0,
  },
}));

export const Title = styled(H2)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const Subtitle = styled(SmallText)(({ theme }) => ({
  color: theme.colors.neutrals.grey1,
}));

export const TermsBlock = styled.div(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(1),
}));

export const TermsLink = styled.a(({ theme }) => ({
  fontSize: 13,
  lineHeight: '20px',
  color: theme.colors.neutrals.grey2,
  textDecoration: 'underline',
  '&:hover': {
    color: theme.colors.neutrals.grey1,
  },
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1),
}));
